import { Card, BlockStack, InlineStack, Text } from "@shopify/polaris";
import { useTranslation } from "../hooks/useTranslation";

/**
 * Compact help card shown throughout the onboarding flow.
 * Displays the support phone number and email so users can reach
 * assistance without leaving the registration process.
 */
export default function OnboardingHelpCard() {
  const { t } = useTranslation();

  return (
    <Card>
      <BlockStack gap="300">
        <BlockStack gap="100">
          <Text variant="headingMd" as="h3">
            {t("onboarding.help.title")}
          </Text>
          <Text variant="bodySm" as="p" tone="subdued">
            {t("onboarding.help.subtitle")}
          </Text>
        </BlockStack>

        <BlockStack gap="200">
          <InlineStack gap="200" blockAlign="center">
            <Text variant="bodyMd" as="p">📞</Text>
            <Text variant="bodyMd" as="p" fontWeight="semibold">
              {t("onboarding.help.phone")}
            </Text>
          </InlineStack>
          <InlineStack gap="200" blockAlign="center">
            <Text variant="bodyMd" as="p">✉️</Text>
            <Text variant="bodyMd" as="p">
              {t("onboarding.help.email")}
            </Text>
          </InlineStack>
        </BlockStack>
      </BlockStack>
    </Card>
  );
}
